import type { TaskStatus } from '@awork/features/task/models/task-status.model'
import type { ProjectStatus } from '@awork/features/project/models/project-status.model'
import type { Tag } from '@awork/_shared/models/tag.model'
import type { IsBillableByDefaultOptions } from '@awork/features/project/models/project-template.model'
import { differenceInCalendarDays } from '@awork/_shared/functions/date-fns-wrappers'
import type { Automation } from '@awork/features/project/models/automation.model'
import type { TaskTemplate } from '../../task/models/task-template.model'
import type { ReferenceDateType, ReferenceDateAnchor } from '@awork/features/project/models/project-template.model'

interface PublicProjectTemplateTaskList {
  id: string
  name: string
  order?: number
  tasks: TaskTemplate[]
}

export interface PublicProjectTemplateProject {
  id?: string
  description?: string
  isBillableByDefault?: IsBillableByDefaultOptions
  defaultTaskListNameForEmails?: string
  tags?: Tag[]
  projectStatuses?: ProjectStatus[]
  taskStatuses?: TaskStatus[]
  taskLists: PublicProjectTemplateTaskList[]
  tasksWithoutList: TaskTemplate[]
  automations: Automation[]
}

export enum PublicProjectTemplateTags {
  GettingStarted = 'onboarding-1',
  Onboarding = 'onboarding-2',
  CreativeAgencies = 'creative-agencies',
  Consulting = 'consulting',
  Technology = 'technology'
}

interface IPublicProjectTemplate {
  id: string
  createdOn?: Date
  createdBy?: string
  updatedOn?: Date
  updatedBy?: string
  name: string
  icon: string
  language: string
  isFavorite?: boolean
  slug: string
  project: PublicProjectTemplateProject
  tags?: (PublicProjectTemplateTags | string)[]
  hasRelativeTasks: boolean
  referenceDateType?: ReferenceDateType
  referenceDateAnchor?: ReferenceDateAnchor
  customReferenceDate?: Date
}

export class PublicProjectTemplate implements IPublicProjectTemplate {
  id: string
  createdOn?: Date
  createdBy?: string
  updatedOn?: Date
  updatedBy?: string
  name: string
  icon: string
  language: string
  isFavorite?: boolean
  slug: string
  project: PublicProjectTemplateProject
  tags?: string[]
  hasRelativeTasks: boolean
  referenceDateType?: ReferenceDateType
  referenceDateAnchor?: ReferenceDateAnchor
  customReferenceDate?: Date

  constructor(publicProjectTemplate: Partial<IPublicProjectTemplate>) {
    Object.assign(this, publicProjectTemplate)

    if (!publicProjectTemplate.tags) {
      this.tags = []
    }
  }

  get isNew(): boolean {
    return differenceInCalendarDays(new Date(), this.createdOn) < 30
  }
}
